const signUpTypes = {
  SET_ACTUAL_STEP: 'SIGNUP/SET_ACTUAL_STEP',
  SET_STEP1: 'SIGNUP/SET_STEP1',
  SET_STEP2: 'SIGNUP/SET_STEP2',
  SET_STEP3: 'SIGNUP/SET_STEP3',
  SET_STEP4: 'SIGNUP/SET_STEP4',
  SET_STEP5: 'SIGNUP/SET_STEP5',
  SET_ERROR: 'SIGNUP/SET_ERROR',
  RESET_STATE: 'SIGNUP/RESET_STATE'
}

export default signUpTypes
